import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, createVNode as _createVNode, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createElementBlock as _createElementBlock, Fragment as _Fragment, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-1db09630"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "tree__header" }
const _hoisted_2 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "text-h5" }, "Штатное расписание", -1))
const _hoisted_3 = { key: 1 }


import { useTreeStore } from '@/store/tree/treeModule';
import Tree from '@/Tree/Tree';
import { onBeforeUnmount, reactive } from 'vue';
import { actionHandler } from '~actions/actionHandler';
import { Action, Button } from '~components/TableComponent/types';
import { useMainStore } from '@/store';
import { TreeItem } from '@/Tree/types';
import { storeToRefs } from 'pinia';
import TreeItemComponent from './TreeItem.vue';
import CustomDropdownButton from '../CustomDropdownButton.vue';
import actionButtons from './treeActionButtons.json';

const __default__ = {
  name: 'TreeComponent',
};

export default /*#__PURE__*/_defineComponent({
  ...__default__,
  setup(__props) {


const treeStore = useTreeStore();
const { treeData } = storeToRefs(treeStore);

const data = reactive({
  root: treeStore.getRoot,
  tree: null as Tree | null,
  selectedItem: null as null | string,
  actionButtons: actionButtons as Button[],
});

if (data.root) {
  data.tree = new Tree(data.root);
  if (data.tree) {
    treeData.value.data.forEach((node) => data.tree?.add(
      node,
      node.id_parent,
      data.tree.traverseDF,
    ));
  }
}

const unsubscribe = treeStore.$onAction(({ name, args, after }) => {
  if (name === 'loadTreeNode') {
    after((result) => {
      if (result) {
        result.data
          .forEach((item) => data.tree?.add(item, result.id_tree, data.tree.traverseDF));
      }
    });
  }
  if (name === 'moveTreeItem') {
    after((result) => {
      const { id_tree_drag, id_tree_drop, type_drop } = args[0];
      const changeOrger = Boolean(type_drop);
      let newParentId: string;
      if (!changeOrger) {
        newParentId = treeData.value.data
          .find((item) => item.id_tree === id_tree_drop)?.id_tree as string;
      } else {
        newParentId = treeData.value.data
          .find((item) => item.id_tree === id_tree_drag)?.id_parent as string;
      }
      const parentParentId = treeData.value.data
        .find((item) => item.id_tree === newParentId)?.id_parent as string;
      const newParentNode = data.tree?.search(newParentId, parentParentId, data.tree.traverseDF);
      const nodeToPaste = treeData.value.data.find((item) => item.id_tree === id_tree_drag);

      if (newParentNode && nodeToPaste) {
        if (changeOrger) {
          const arr = newParentNode.children;
          const sourceIndex = arr.findIndex((item) => item.data.id_tree === id_tree_drag);
          let targetIndex = arr.findIndex((item) => item.data.id_tree === id_tree_drop);
          if (type_drop === 1) {
            targetIndex += 1;
          }
          if (sourceIndex < targetIndex) {
            data.tree?.add(nodeToPaste, newParentId, data.tree.traverseDF, targetIndex);
            data.tree?.remove(id_tree_drag, newParentId, data.tree.traverseDF);
          } else {
            data.tree?.remove(id_tree_drag, newParentId, data.tree.traverseDF);
            data.tree?.add(nodeToPaste, newParentId, data.tree.traverseDF, targetIndex);
          }
        } else {
          const oldParentId = nodeToPaste.id_parent;
          nodeToPaste.id_parent = newParentId;
          data.tree?.add(nodeToPaste, newParentId, data.tree.traverseDF);
          newParentNode.data.has_children = 1;
          data.tree?.remove(id_tree_drag, oldParentId, data.tree.traverseDF);
        }
      }
    });
  }
});

const unsubscribeEvents = useMainStore().$onAction(({ name, args, after }) => {
  if (name === 'dispatchEvent') {
    after((result) => {
      if (typeof result === 'boolean' || !args[1]) {
        return;
      }
      if (result.data?.[0] && result.data?.[0].error) {
        useMainStore().showMessage(result.data[0].error);
        return;
      }
      const newNode = result.data?.[0] as TreeItem;
      const newType = result.data?.[0] as { type: 1 | 2 };
      const targetNodeId = args[1].id_tree;
      const targetItem = treeData.value.data.find((item) => item.id_tree === targetNodeId);
      if (!targetItem) {
        return;
      }

      const targetNode = data.tree?.search(
        targetNodeId,
        targetItem.id_parent,
        data.tree.traverseDF,
      );

      if (targetNode) {
        switch (args[0]) {
          case 'POST:node_create_v2':
            data.tree?.add(newNode, targetNodeId, data.tree.traverseDF);
            targetNode.data.has_children = 1;

            treeStore.addTreeItem(result.data[0] as TreeItem);

            break;
          case 'POST:node_del_v2':
            data.tree?.remove(targetNodeId, targetItem.id_parent, data.tree.traverseDF);

            if (!targetNode.children.length) {
              targetNode.data.has_children = 0;
            }
            break;
          case 'POST:node_rename':
            targetNode.data.title = args[1].text;
            break;
          case 'POST:node_retype':
            targetNode.data.id_type = newType.type;
            break;
          case 'POST:tree_clone':
            data.tree?.add(newNode, targetNodeId, data.tree.traverseDF);
            break;
          default:
            break;
        }
      }
    });
  }
});

onBeforeUnmount(() => {
  unsubscribe();
  unsubscribeEvents();
});

const select = (params: { id_tree: string, type: 0 | 1 | 2, type_drop: 0 | 1 }) => {
  data.selectedItem = params.id_tree;
  treeStore.setCurrentItem(Number(params.id_tree));
  data.actionButtons = actionButtons.map((btn) => ({
    ...btn,
    disable: false,
  })) as Button[];
  const addBtn = data.actionButtons.find((btn) => btn.action.customParam === 'addTreeItem');
  const hazadrsBtn = data.actionButtons.find((btn) => btn.action.name === 'HazardsModal');
  const cloneBtn = data.actionButtons.find((btn) => btn.action.customParam === 'cloneTreeItem');
  const currentItem = treeData.value.data.find((item) => item.id_tree === params.id_tree);

  switch (params.type) {
    case 0: {
      data.actionButtons = data.actionButtons.map((btn) => ({
        ...btn, disable: true,
      }));
      if (addBtn) {
        addBtn.disable = false;
      }
      break;
    }
    case 1: {
      if (hazadrsBtn) {
        hazadrsBtn.disable = true;
      }
      break;
    }
    case 2: {
      if (cloneBtn) {
        cloneBtn.disable = true;
      }
      if (addBtn) {
        addBtn.action = {
          name: 'EmployeeAddModal',
          type: 'modal',
          customParam: { ...currentItem },
        };
      }
      break;
    }
    default:
      break;
  }

  if (currentItem) {
    data.actionButtons = data.actionButtons.map((btn) => ({
      ...btn,
      action: {
        ...btn.action,
        customParam: {
          ...currentItem,
          type: btn.action.customParam,
          mode: 'full',
        },
      },
    }));
  }
};

const onAction = (action: Action) => {
  actionHandler(action);
};


return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createElementVNode("div", _hoisted_1, [
      _hoisted_2,
      _createVNode(CustomDropdownButton, {
        label: "Действия",
        buttons: data.actionButtons,
        disable: !data.selectedItem,
        onAction: onAction
      }, null, 8, ["buttons", "disable"])
    ]),
    (data.tree)
      ? (_openBlock(), _createBlock(TreeItemComponent, {
          key: 0,
          style: {"overflow":"auto"},
          item: data.tree?._root,
          selectedItem: data.selectedItem,
          onSelect: select
        }, null, 8, ["item", "selectedItem"]))
      : (_openBlock(), _createElementBlock("div", _hoisted_3, " Здесь пока нет структуры ( "))
  ], 64))
}
}

})